import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import defaultImage from "../../../media/background_images/default-image-sapore.jpg";

export class MarketplaceSearchFeature {
    constructor(application, articleOrCategoryName) {
        this._application = application
        this._articleOrCategoryName = articleOrCategoryName
        this._articles = []
        this._loaded = false

        makeObservable(this, {
            _articles: observable,
            _loaded: observable,
            loaded: computed,
        });
    }

    async load() {
        await this.searchArticles()
        this._finishedLoading()
    }

    _finishedLoading() {
        this._loaded = true;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get articleOrCategoryName(){
        return this._articleOrCategoryName
    }

    set articleOrCategoryName(value){
        return this._articleOrCategoryName = value
    }

    async searchArticles() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._articles = this.convertArticlesResponse(response.articles())
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error fetching article price list.")
            }
        });
        return this._application.apiClient().searchArticles(this._articleOrCategoryName, this._application.session().getCustomer(), responseHandler);
    }

    convertArticlesResponse(articles) {
        return articles.map((article) => {return {
            Id: article.code,
            Producto: {
                Archivo: this.productImage(article),
                Nombre: article.name,
                NombreFantasia: article.fantasy_name,
            }
        }
        })
    }

    articles() {
        return this._articles
    }

    productImage(article){
        let url = article.file;
        if (url.includes('invalid_url')){
            url = defaultImage
        }
        return url;
    }

    canAddProduct() {
        // FIXME: Duplicated code!
        const business = this._application.business();
        const userRoles = this._application.session().user().roles;
        return userRoles.includes(business.marketplace_operational_role()) || userRoles.includes(business.marketplace_general_administrator_role());
    }
}